const ReviewModal = ({
  setShowModal,
  formData,
  handleInputChange,
  handleImageChange,
  handleSubmit,
  isSubmitting = false, 
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-gray-800 p-8 rounded-lg w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-blue-400">
            Share Your Experience
          </h3>
          <button
            onClick={() => setShowModal(false)}
            className="text-gray-400 hover:text-white"
            disabled={isSubmitting} 
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Your Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full p-2 bg-gray-700 rounded border border-gray-600 text-white"
              required
              disabled={isSubmitting}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Country
            </label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              className="w-full p-2 bg-gray-700 rounded border border-gray-600 text-white"
              required
              disabled={isSubmitting}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Your Experience
            </label>
            <textarea
              name="comment"
              value={formData.comment}
              onChange={handleInputChange}
              rows="4"
              className="w-full p-2 bg-gray-700 rounded border border-gray-600 text-white"
              required
              disabled={isSubmitting}
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Your Photo
            </label>
            <div className="flex items-center space-x-4">
              <label
                className={`cursor-pointer p-2 rounded border transition ${
                  isSubmitting
                    ? "bg-gray-600 border-gray-500 text-gray-400"
                    : "bg-gray-700 border-gray-600 hover:bg-gray-600"
                }`}
              >
                <span>{formData.image ? "Change Image" : "Upload Image"}</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="hidden"
                  disabled={isSubmitting}
                />
              </label>

              {formData.imagePreview && (
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-400">
                  <img
                    src={formData.imagePreview}
                    alt="Preview"
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className={`w-full py-2 px-4 rounded transition duration-300 ${
                isSubmitting
                  ? "bg-gray-600 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              } text-white`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Review"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReviewModal;
